/**
 * Created by Wang Chong on 2017/10/26.
 */
import needLoginUrlList from '../../../../setting/loginCheck.json';

export default function (pathname) {
    pathname = pathname.replace('/', '');
    return needLoginUrlList.some(function (i) {
        const pattern = new RegExp(`^${pathname}$`),
            needLoginPathname = i.replace("./tpl/", "");
        return pattern.test(needLoginPathname);
    });
};
